import { createApi } from '../lib/api.js';
import { escapeHtml, formatMoney, buildBookingUrl } from '../lib/utils.js';

export function initServiceSelector(root, cfg) {
	const api = createApi(cfg);
	const category = (root.getAttribute('data-category') || '').trim();
	const bookingUrl = (cfg.bookingPageUrl || '').trim();
	const hasBookingUrl = bookingUrl.length > 0;

	if (!hasBookingUrl) {
		console.warn(
			'[BookPress] bookingPageUrl is not set. Add a [bookpress_booking] page or configure BookPressPublic.bookingPageUrl.'
		);
	}

	root.innerHTML =
		'<p class="bookpress-loading">Loading services…</p>';

	const query = category ? { category } : undefined;

	api
		.get('/services', query)
		.then((services) => {
			const list = services || [];

			if (!list.length) {
				root.innerHTML =
					'<p class="bookpress-empty">No services found' +
					(category ? ' in this category.' : '.') +
					'</p>';
				return;
			}

			const cards = list
				.map((service) => {
					const img = service.service_image
						? '<img class="bookpress-service-card__image" src="' +
							escapeHtml(service.service_image) +
							'" alt="" loading="lazy" />'
						: '<div class="bookpress-service-card__image bookpress-service-card__image--placeholder" aria-hidden="true"></div>';

					const categoryTag = service.category
						? '<span class="bookpress-tag">' +
							escapeHtml(service.category) +
							'</span> '
						: '';

					const bookParams = hasBookingUrl
						? ' data-service-id="' + escapeHtml(String(service.id)) + '"'
						: '';
					const bookDisabled = hasBookingUrl ? '' : ' disabled';

					return (
						'<article class="bookpress-service-card">' +
						img +
						'<div class="bookpress-service-card__body">' +
						'<div class="bookpress-service-card__tags">' +
						categoryTag +
						'<span class="bookpress-badge">' +
						escapeHtml(String(service.duration)) +
						' min</span></div>' +
						'<h3 class="bookpress-service-card__title">' +
						escapeHtml(service.name) +
						'</h3>' +
						'<p class="bookpress-service-card__price">From ' +
						escapeHtml(formatMoney(service.base_price, cfg.currency)) +
						'</p>' +
						'<button type="button" class="bookpress-btn bookpress-btn--primary bookpress-service-card__book"' +
						bookParams +
						bookDisabled +
						'>Book Now</button>' +
						'</div></article>'
					);
				})
				.join('');

			root.innerHTML =
				'<div class="bookpress-service-grid">' + cards + '</div>';

			root.querySelectorAll('.bookpress-service-card__book').forEach((btn) => {
				btn.addEventListener('click', () => {
					if (!hasBookingUrl) {
						return;
					}
					const id = btn.getAttribute('data-service-id');
					window.location.href = buildBookingUrl(bookingUrl, {
						service_id: id,
						bookpress_service: id,
					});
				});
			});
		})
		.catch((err) => {
			root.innerHTML =
				'<p class="bookpress-error">' + escapeHtml(err.message) + '</p>';
		});
}
